import {
  useEffect,
  useState,
} from 'react'

const COOKIE_NAME =
  'kr_cookie_consent'

const ACCEPT_MAX_AGE =
  60 * 60 * 24 * 365

const DECLINE_MAX_AGE =
  60 * 60

const DECLINE_REDIRECT =
  'https://ya.ru/'

function hasConsentCookie(): boolean {
  return document.cookie
    .split('; ')
    .some((part) =>
      part.startsWith(
        `${COOKIE_NAME}=`,
      ),
    )
}

function setConsentCookie(
  value: string,
  maxAge: number,
): void {
  const secure =
    window.location.protocol === 'https:'
      ? '; Secure'
      : ''

  document.cookie =
    `${COOKIE_NAME}=` +
    `${encodeURIComponent(value)}` +
    `; Max-Age=${maxAge}` +
    '; Path=/' +
    '; SameSite=Lax' +
    secure
}

export function CookieBanner() {
  const [visible, setVisible] =
    useState(false)

  useEffect(() => {
    setVisible(
      !hasConsentCookie(),
    )
  }, [])

  function handleAccept(): void {
    setConsentCookie(
      'accepted',
      ACCEPT_MAX_AGE,
    )

    try {
      window.localStorage.setItem(
        COOKIE_NAME,
        'accepted',
      )
    } catch {
      // localStorage может быть
      // недоступен в браузере.
    }

    setVisible(false)
  }

  function handleDecline(): void {
    setConsentCookie(
      'declined',
      DECLINE_MAX_AGE,
    )

    try {
      window.localStorage.setItem(
        COOKIE_NAME,
        'declined',
      )
    } catch {
      // localStorage может быть
      // недоступен в браузере.
    }

    window.location.assign(
      DECLINE_REDIRECT,
    )
  }

  if (!visible) {
    return null
  }

  return (
    <aside
      className="kr-cookie"
      role="dialog"
      aria-live="polite"
      aria-label="Уведомление о cookies"
    >
      <div className="kr-cookie__inner">
        <div className="kr-cookie__text">
          <strong className="kr-cookie__title">
            Привет! 👋
          </strong>

          <p className="kr-cookie__desc">
            Мы используем cookies (как и
            большинство сайтов), чтобы
            Академия Кракен (Kraken Academy)
            работала стабильно: сохраняла
            сессии, настройки интерфейса и
            помогала нам понимать, что
            улучшать. Если ты не хочешь
            использовать cookies — можешь
            отказаться, и тогда мы
            перенаправим тебя со страницы.
          </p>

          <a
            className="kr-cookie__link"
            href="/privacy/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Подробнее в политике
          </a>
        </div>

        <div className="kr-cookie__actions">
          <button
            type="button"
            className="kr-cookie__button kr-cookie__button--accept"
            onClick={handleAccept}
          >
            Принимаю
          </button>

          <button
            type="button"
            className="kr-cookie__button kr-cookie__button--decline"
            onClick={handleDecline}
          >
            Не принимаю
          </button>
        </div>
      </div>
    </aside>
  )
}
